// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"52":"consultation","93":"reimbursement","368":"labs-v2"}[chunkId] || chunkId) + "." + {"52":"ec855637","93":"c9888a36","189":"2e48116f","368":"0aa192df","525":"29d2dabb","571":"8e7c411a","659":"ec855637","721":"29d2dabb","834":"e869ad06"}[chunkId] + ".chunk.css";
};